import { render } from "./IconAddCircle.vue?vue&type=template&id=a65f14ee"
import script from "./IconAddCircle.vue?vue&type=script&lang=js"
export * from "./IconAddCircle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__